import { apiService as api } from './api';
import { Abastecimento, ApiResponse, RespostaPaginada } from '../types';

export interface AbastecimentosFilters {
  veiculo_id?: number;
  motorista_id?: number;
  tipo_combustivel?: string;
  data_inicio?: string;
  data_fim?: string;
  cidade?: string;
  tanque_cheio?: boolean;
  sort_by?: string;
  sort_order?: string;
  per_page?: number;
  page?: number;
}

export interface AbastecimentosResponse {
  success: boolean;
  data: Abastecimento[];
  message?: string;
  pagination: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface AbastecimentoResponse {
  success: boolean;
  data: Abastecimento;
  message?: string;
}

export interface DeleteResponse {
  success: boolean;
  message: string;
}

export interface EstatisticasResponse {
  success: boolean;
  data: {
    geral: {
      total_abastecimentos: number;
      total_litros: number;
      total_gasto: number;
      media_preco_litro: number;
      consumo_medio: number;
      km_total_rodado: number;
      abastecimentos_tanque_cheio: number;
      abastecimentos_parciais: number;
    };
    por_combustivel: any[];
    por_posto: any[];
  };
}

export const abastecimentosService = {
  // Listar abastecimentos com filtros
  getAbastecimentos: async (filters: AbastecimentosFilters = {}): Promise<RespostaPaginada<Abastecimento>> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<RespostaPaginada<Abastecimento>>(`/v1/abastecimentos?${params.toString()}`);
    return response;
  },

  // Buscar abastecimento por ID
  getAbastecimento: async (id: number): Promise<AbastecimentoResponse> => {
    const response = await api.get<AbastecimentoResponse>(`/v1/abastecimentos/${id}`);
    return response;
  },

  // Criar novo abastecimento
  createAbastecimento: async (abastecimento: Partial<Abastecimento>): Promise<AbastecimentoResponse> => {
    const response = await api.post<AbastecimentoResponse>('/v1/abastecimentos', abastecimento);
    return response;
  },

  // Atualizar abastecimento
  updateAbastecimento: async (id: number, abastecimento: Partial<Abastecimento>): Promise<AbastecimentoResponse> => {
    const response = await api.put<AbastecimentoResponse>(`/v1/abastecimentos/${id}`, abastecimento);
    return response;
  },

  // Excluir abastecimento
  deleteAbastecimento: async (id: number): Promise<DeleteResponse> => {
    const response = await api.delete<DeleteResponse>(`/v1/abastecimentos/${id}`);
    return response;
  },

  // Calcular estatísticas
  getEstatisticas: async (filters: any = {}): Promise<EstatisticasResponse> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<EstatisticasResponse>(`/v1/abastecimentos/estatisticas?${params.toString()}`);
    return response;
  },

  // Relatório de consumo por veículo
  getRelatorioConsumo: async (filters: any = {}): Promise<ApiResponse<any[]>> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<ApiResponse<any[]>>(`/v1/abastecimentos/relatorio/consumo?${params.toString()}`);
    return response;
  },

  // Últimos abastecimentos de um veículo
  getUltimosAbastecimentos: async (veiculoId: number, limit: number = 10): Promise<ApiResponse<Abastecimento[]>> => {
    const response = await api.get<ApiResponse<Abastecimento[]>>(`/v1/abastecimentos/veiculo/${veiculoId}/ultimos?limit=${limit}`);
    return response;
  },
};
